import { render, staticRenderFns } from "./AuthenticationView.vue?vue&type=template&id=5df81a49&"
import script from "./AuthenticationView.vue?vue&type=script&lang=js&"
export * from "./AuthenticationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports